import * as React from "react";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  CircularProgress,
  Stack,
} from "@mui/material";

const Imagen = ({ card, index }) => {
  return (
    <React.Fragment>
      <Grid key={index} size={12}>
        <Card
          sx={{
            height: "100%",
            minHeight: "40px",
            display: "flex",
            flexDirection: "column",
          }}
          variant="outlined"
        >
          {card.IMG ? (
            <CardMedia
              sx={{
                backgroundSize: "contain",
              }}
              image={card.IMG}
              title={card.Titulo}
              component={card.Src}
              controls
              preload="none"
              onClick={(e) => {
                if (card.Url && card.Url !== null && card.Url !== "")
                  window.location.href = card.Url;
              }}
            />
          ) : (
            <CardContent
              sx={{
                height: "100%",
                width: "100%",
              }}
            >
              <Stack
                sx={{
                  width: "100%",
                  height: "100%",
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <CircularProgress
                  sx={{
                    color: "#006699",
                    m: "auto",
                  }}
                />
              </Stack>
            </CardContent>
          )}
        </Card>
      </Grid>
    </React.Fragment>
  );
};
export default Imagen;
